import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from '../types';

interface HtmlForEmailProps {
  fields: Field[];
  fieldValues: { [key: string]: any };
  email: string;
  name: string;
  lastName: string;
}

export const HtmlForEmail: FC<HtmlForEmailProps> = ({ fields, fieldValues, email, name, lastName }) => {
  const { t } = useTranslation();
  return (
    <div>
      <h3 title={t('supportForms.email.title', { email })} />
      <hr />
      <span >
        {`${t('supportForms.fields.name')}: ${name}`}
      </span>
      <br/>
      <span>
        {`${t('supportForms.fields.lastName')}: ${lastName}`}
      </span>
      <br/>
      {
        fields.map(({ label, name, fieldType }) => fieldType !== 'file' && (
          <Fragment key={name}>
            <span>
              {`${label}: ${fieldValues[name]}`}
            </span>
            <br />
          </Fragment>
        ))
      }
      <hr />
    </div>
  );
};
